import { render, staticRenderFns } from "./resend-user-invitation-overlay.vue?vue&type=template&id=c630b7a6"
import script from "./resend-user-invitation-overlay.vue?vue&type=script&lang=js"
export * from "./resend-user-invitation-overlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports